export enum SensorDataFileActionTypes {
  GET_SENSOR_DATA_FILES = "@@SENSOR_DATA_FILES/GET_SENSOR_DATA_FILES",
  GET_SENSOR_DATA_FILES_SUCCESS = "@@SENSOR_DATA_FILES/GET_SENSOR_DATA_FILES_SUCCESS",
  GET_SENSOR_DATA_FILES_FAILURE = "@@SENSOR_DATA_FILES/GET_SENSOR_DATA_FILES_FAILURE",

  GET_SENSOR_DATA_FILE = "@@SENSOR_DATA_FILES/GET_SENSOR_DATA_FILE",
  GET_SENSOR_DATA_FILE_SUCCESS = "@@SENSOR_DATA_FILES/GET_SENSOR_DATA_FILE_SUCCESS",
  GET_SENSOR_DATA_FILE_FAILURE = "@@SENSOR_DATA_FILES/GET_SENSOR_DATA_FILE_FAILURE",

  GET_SENSOR_DATA_FILE_VALUES = "@@SENSOR_DATA_FILES/GET_SENSOR_DATA_FILE_VALUES",
  GET_SENSOR_DATA_FILE_VALUES_SUCCESS = "@@SENSOR_DATA_FILES/GET_SENSOR_DATA_FILE_VALUES_SUCCESS",
  GET_SENSOR_DATA_FILE_VALUES_FAILURE = "@@SENSOR_DATA_FILES/GET_SENSOR_DATA_FILE_VALUES_FAILURE",

  CREATE_SENSOR_DATA_FILE = "@@SENSOR_DATA_FILES/CREATE_SENSOR_DATA_FILE",
  CREATE_SENSOR_DATA_FILE_SUCCESS = "@@SENSOR_DATA_FILES/CREATE_SENSOR_DATA_FILE_SUCCESS",
  CREATE_SENSOR_DATA_FILE_FAILURE = "@@SENSOR_DATA_FILES/CREATE_SENSOR_DATA_FILE_FAILURE",

  SET_FILE_UPLOADING_PERCENTAGE = "@@SENSOR_DATA_FILES/SET_FILE_UPLOADING_PERCENTAGE",
  CLEAR_SENSOR_DATA_FILES = "@@SENSOR_DATA_FILES/CLEAR_SENSOR_DATA_FILES",
  CLEAR_SENSOR_DATA_FILE = "@@SENSOR_DATA_FILES/CLEAR_SENSOR_DATA_FILE",
  SET_FILTER = "@@SENSOR_DATA_FILES/SET_FILTER",
  SET_CURRENT_FILE_VALUES_FILTER = "@@SENSOR_DATA_FILES/SET_CURRENT_FILE_VALUES_FILTER",
}
